import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../configure';
import { EXCHANGES } from '@/src/common/enum';

export interface ETFDetailsState {
  data: {
    exchange?: EXCHANGES;
    cocode?: string;
    isloading?: boolean;
  };
}

export const initialState: ETFDetailsState = {
  data: {},
};

export const etfDetailsSlice = createSlice({
  name: 'etfDetails',
  initialState,
  reducers: {
    updateETFExchangeAndCocode: (state, action) => {
      state.data.exchange = action.payload.exchange;
      state.data.cocode = action.payload.cocode;
    },
  },
});

export const { updateETFExchangeAndCocode } = etfDetailsSlice.actions;

export const selectEtfDetails = (state: RootState) => state.etfDetails;

export default etfDetailsSlice.reducer;
